var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"project-overlay"}},[_c('h1',{staticClass:"slate-bold"},[_vm._v("This project has been marked as complete")])])}]

export { render, staticRenderFns }